// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aRti","placeholdersHeader":"styles_placeholdersHeader__1Lr25","editorStyle":"styles_editorStyle__zm1W9","placeholdersBox":"styles_placeholdersBox__2Dd2b"};